import './ButtonKitFixer.css';

import React from 'react';

import classname from '@search/classname/src';

const cn = classname.bind(null, 'ButtonKitFixer');

export function ButtonKitFixer({
    children
}: {
    children?: React.ReactNode;
}) {
    return (<div className={cn()}>{children}</div>);
}
